import icone from '../../assets/images/Rectangle.png';
import icone2 from '../../assets/images/Icon.png';
import infoIcon from '../../assets/images/info.png';
import heartIcon from '../../assets/images/coeur.png';
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const DoctorDashboard = () => {
    const navigate = useNavigate();
    const [UserData, setUserData] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [departments, setDepartments] = useState([]);
    const popoverRefs = useRef([]);

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);

    // Fetch appointments
    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('Token not found');
                }

                const hospitalIds = Array.isArray(UserData.hospital_id) ? UserData.hospital_id : [UserData.hospital_id];

                // Create a request for each hospitalId
                const promises = hospitalIds.map(hospitalId =>
                    api.get(`/clinic/getAppointmentlist?hospitalId=${hospitalId._id || hospitalId}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                );

                const responses = await Promise.all(promises);

                // Combine all responses
                const allAppointments = responses.flatMap(response => response.data);

                // Filter appointments with paymentStatus true
                const appointmentsWithPaymentStatus = allAppointments.filter(appointment => appointment.paymentStatus === true);

                // Add vital sign check for each appointment
                const appointmentsWithSignVitalStatus = await Promise.all(
                    appointmentsWithPaymentStatus.map(async (appointment) => {
                        const signVitalExists = await fetchSignVitalStatus(appointment._id);
                        return {
                            ...appointment,
                            signVitalExists,
                        };
                    })
                );

                setAppointments(appointmentsWithSignVitalStatus);

            } catch (error) {
                console.error('Error fetching appointments:', error);
                toast.error("Failed to fetch appointments");
            }
        };

        if (UserData && UserData.hospital_id) {
            fetchAppointments();
        }
    }, [UserData]);

    // Function to check if vital signs exist for an appointment
    const fetchSignVitalStatus = async (appointmentId) => {
        try {
            const response = await api.get(`/clinic/signvitalforappointment/${appointmentId}`);
            return response.data.signVitaldata;
        } catch (error) {
            console.error('Error checking vital signs:', error);
            return false;
        }
    };

    // Fetch departments
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await api.get(`/api/departments`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });
                setDepartments(response.data.data);
            } catch (error) {
                console.error('Error fetching departments:', error);
            }
        };
        fetchDepartments();
    }, []);

    // Initialize popovers
    useEffect(() => {
        popoverRefs.current.forEach((popoverEl) => {
            if (popoverEl && window.bootstrap) {
                new window.bootstrap.Popover(popoverEl, {
                    html: true,
                    trigger: 'click',
                });
            }
        });
    }, [appointments]);

    const handleViewHistory = () => {
        navigate("/hospitaladmin/appointment_history");
    };

    const handleViewHistory2 = () => {
        navigate("/hospitaladmin/patient_details");
    };

    const handleviewcalendar = (doctorId) => {
        navigate(`/hospitaladmin/doctor/calendar/${doctorId}`);
    };

    const doctorId = UserData._id;

    return (
        <div className='enrol'>
            <div className="py-4 doc" style={{ fontFamily: 'Arial, sans-serif' }}>
                <p className="text-primary ">{new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
                <h2 className="text-primary fw-bold fs-1 mb-3" style={{color:"#0056b3"}}>Good morning, {UserData.firstname} {UserData.lastname}</h2>

                <div className="row mb-4">
                    <div className="col-md-4" style={{ borderRadius: "20px" }}>
                        <div className="card text-white mb-3 text-center" style={{ borderRadius: "20px" }} >
                            <div className="card-body" style={{
                                borderRadius: "20px", background: 'linear-gradient(180deg, #003366, #001f33)'
                            }}>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <h5 className="card-title text-start">Number of upcoming appointments</h5>
                                        <p className="card-text display-4 text-start">{appointments.filter(apt => apt.status === "Scheduled").length || 0}</p>
                                    </div>
                                    <div className='text-end align-items-left'>
                                        <img src={icone2} alt="Icon" />
                                        {/* <p className="mt-4">+11.01%</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card text-white mb-3 text-center" style={{ borderRadius: "20px" }}>
                            <div className="card-body" style={{ borderRadius: "20px", background: ' linear-gradient(180deg, #FF9800, #FFC107)' }}>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <h5 className="card-title">Appointment Cancelled</h5>
                                        <p className="card-text display-4">{appointments.filter(dept => dept.status === "Cancelled").length}</p>
                                    </div>
                                    <div className='text-end align-items-left'>
                                        <img src={icone2} alt="Icon" />
                                        {/* <p className="mt-4">+6.08%</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card text-white mb-3 text-center" style={{ borderRadius: "20px" }}>
                            <div className="card-body" style={{ borderRadius: "20px", background: 'linear-gradient(180deg, #28A745, #4CAF50)' }}>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <h5 className="card-title">Appointment Completed</h5>
                                        <p className="card-text display-4">{appointments.filter(dept => dept.status === "Completed").length}</p>
                                    </div>
                                    <div className='text-end align-items-left'>
                                        <img src={icone2} alt="Icon" />
                                        {/* <p className="mt-4">+6.08%</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 bg-white" style={{ borderRadius: "20px" }}>
                        <div className="card p-4">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className='card-title fw-bold text-info' style={{color:"#0056b3"}}>Upcoming appointments</h5>
                                    {/* <div className="text-end">
                                        <button className="btn btn-primary me-2" onClick={() => handleviewcalendar(doctorId)}>
                                            View calendar <i className="bi bi-calendar3"></i>
                                        </button>
                                        <button className="btn btn-primary" onClick={handleViewHistory}>
                                            View history <i className="bi bi-clock-history"></i>
                                        </button>
                                    </div> */}
                                </div>

                                {/* <div className="row mb-3">
                                    <div className="col-md-4" style={{ borderRadius: '15px' }}>
                                        <div className="input-group" style={{ borderRadius: '15px 0px 0px 15px' }}>
                                            <span className="input-group-text" style={{ borderRadius: '15px 0px 0px 15px' }}>
                                                <i className="bi bi-search"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search..."
                                                style={{ borderRadius: '0px 15px 15px 0px' }}
                                            />
                                        </div>
                                    </div>
                                </div> */}

                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead className="thead-light">
                                            <tr className="text-primary">
                                        <th className="text-muted p-4">AppointmentID</th>
                                        <th scope="col" className="text-muted p-4">Time</th>
                                        <th scope="col" className="text-muted p-4">Date</th>
                                        <th scope="col" className="text-muted p-4">Patient Name</th>
                                        <th scope="col" className="text-muted p-4">Phone</th>
                                        <th scope="col" className="text-muted p-4">Department</th>
                                        <th scope="col" className="text-muted p-4">Status</th>
                                        <th scope="col" className="text-muted p-4">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {appointments.filter(apt => apt.status === "Scheduled").map((appointment, index) => (
                                                <tr key={index}>
                                                    <td>{appointment.AppointmentCode}</td>
                                                    <td className="text-primary">
                                                        <p style={{lineHeight:'5px',marginTop:'15px'}}>{appointment.appointmentTime}</p>
                                                        <p style={{lineHeight:'5px',width:'40px',backgroundColor:'blue',height:'1px'}}></p>
                                                        <p style={{lineHeight:'5px'}}>{appointment.appointmentEndTime}</p>
                                                    </td>
                                                    <td>{appointment.appointmentDate?.split("T")[0]}</td>
                                                    <td>{appointment.patientId?.firstname || 'Unknown'} {appointment.patientId?.lastname || 'Unknown'}</td>
                                                    <td>{appointment.patientId?.phone || 'N/A'}</td>
                                                    <td>
                                                    {(departments.filter(dept => dept._id === appointment.department))[0].name}

                                                    </td>
                                                    <td>
                                                        {/* Consultation en personne */}
                                                        {appointment?.type_consultation === 'inperson' && (
                                                            <a
                                                                href={`/hospitaladmin/intakeformconsult?patient_id=${appointment?.patientId?._id}&appointmentId=${appointment._id}`}
                                                                className="btn"
                                                                style={{ color: '#0056B3', backgroundColor: '#DFEAF5' }}
                                                            >
                                                                Start Appointment
                                                            </a>
                                                        )}

                                                        {/* Consultation en ligne */}
                                                        {appointment?.type_consultation === 'online' && (
                                                            <a
                                                                href={`/hospitaladmin/telemedecine?patient_id=${appointment?.patientId?._id}&appointmentId=${appointment._id}`}
                                                                className="btn"
                                                                style={{ color: '#1A5D1A', backgroundColor: '#28A7452B' }}
                                                            >
                                                                Start Online Appointment
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <img
                                                            className="btn me-2 cursor-pointer"
                                                            data-bs-toggle="popover"
                                                            data-bs-title="Vital Signs"
                                                            data-bs-content={`Body Temperature: <strong style="color: red;">fffffffffffffffffff</strong><br /><hr>Blood Pressure: <strong>ffffffffffffffff</strong><br />Note: <strong>}</strong>`}
                                                            data-bs-placement="bottom"
                                                            data-bs-custom-class="custom-popover"
                                                            src={heartIcon || icone2}
                                                            ref={(el) => (popoverRefs.current[index] = el)}
                                                            alt="Heart Icon"
                                                        />
                                                        <img
                                                            className="me-2 btn cursor-pointer"
                                                            onClick={handleViewHistory2}
                                                            src={infoIcon || icone}
                                                            alt="Info Icon"
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            {appointments.length === 0 && (
                                                <tr>
                                                    <td colSpan="6" className="text-center">No appointments found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="text-end">Showing 1-{Math.min(appointments.length, 9)} of {appointments.length}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DoctorDashboard;